import { useEffect, useState } from 'react'

const DAY = 24 * 60 * 60

/**
 * Counts down from 23:59:59 and loops when it reaches zero.
 * Returns zero-padded hours, minutes and seconds.
 */
export function useCountdown(): {
  hours: string
  minutes: string
  seconds: string
} {
  const [remaining, setRemaining] = useState(DAY - 1)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? DAY - 1 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  const pad = (value: number) => String(value).padStart(2, '0')

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
